import { Spinner } from "@stackje/shared-components/ui/spinner";

export const Loading = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center pb-safe pt-safe pl-safe pr-safe">
      <Spinner size="large" />
    </div>
  );
};
